(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aqua-ox-animations-controller"] && !Shopify.designMode) return;
  try {
    
    const options = {
        root: null,
        //            top right bottom left
        rootMargin: "100px 0px 100px 0px",
        threshold: 1,
    }

    window.AquaOx.animationController = {}
    window.AquaOx.animationController.animations = []
    window.AquaOx.animationController.observerCallbacks = (entries) => {
        window.AquaOx.animationController.animations.forEach((fn) => {
            if (typeof fn === "function") {
                fn(entries)
            }
        })
    }

    window.AquaOx.animationController.observer = new IntersectionObserver((entries, observer) => {
        window.AquaOx.animationController.observerCallbacks(entries)
    }, options);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqua-ox-collections-whole-house"]) return;
  try {
    
    const video = document.querySelector('video');
    const play = document.querySelector('.play');
    const pause = document.querySelector('.pause');
    video.addEventListener("ended", () => {
        video.play()
    });

    play.addEventListener("click", () => {
        video.play();
        video.classList.toggle("paused");
    })

    pause.addEventListener("click", () => {
        video.pause();
        video.classList.toggle("paused");
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqua-ox-faq"]) return;
  try {
    
    const details = document.querySelectorAll('#aqua-ox-faq .faq-grid .faq');

    details[0].parentElement.parentElement.addEventListener("click", (evt) => {
        if (evt.target.localName !== "button") {
            return
        }

        const controls = evt.target.getAttribute("aria-controls");
        if (controls) {
            const content = document.querySelector(`#aqua-ox-faq #${controls}`);
            content.querySelector('button').classList.toggle("opened")
            const expand = content.getAttribute("aria-expanded") === 'false' ? true : false
            content.setAttribute("aria-expanded", expand)
            if (expand) {
                content.style.maxHeight = `${+content.dataset.maxHeight + 20}px`;
            } else {
                content.style.maxHeight = `${+content.dataset.closedHeight + 20}px`;
            }
        }
    })

    for (let i = 0; i < details.length; i++) {
        const detail = details[i].querySelector('button')
        const maxHeight = detail.parentElement.getBoundingClientRect().height
        const closedHeight = detail.getBoundingClientRect().height

        detail.parentElement.style.maxHeight = `${+closedHeight + 20}px`;
        detail.parentElement.setAttribute("aria-expanded", false)
        detail.parentElement.dataset.maxHeight = maxHeight;
        detail.parentElement.dataset.closedHeight = closedHeight;
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqua-ox-featured-on"] && !Shopify.designMode) return;
  try {
    
    (() => {
        if (window?.AquaOx?.animationController === undefined) {
            return console.warn("AquaOx Animations Disabled: Aqua Ox Animation Controller not present")
        }

        const observer = window.AquaOx.animationController.observer;
        const container = document.querySelector('.aqua-ox-featured');

        // create the animation
        window.AquaOx.animationController.animations.push((entries) => {
            entries.forEach((entry) => {
                if (container.contains(entry.target) === false) {
                    return;
                }
                
                if (entry.isIntersecting) {
                    entry.target.classList.add("animate");
                }
            })
        })

        // observe elem to play animation
        const text = document.querySelector(".aqua-ox-featured .text");
        text.style.animationDelay = `0.25s`;
        observer.observe(text);

        const images = [...document.querySelectorAll(".aqua-ox-featured .images img")].reverse();
        images.reduce((prev, elem, idx) => {
            // fade in towards the center
            const reflection = images.length - (idx + 1);
            if (idx !== 0 && reflection + 1 > idx) {
                prev.push(idx)
                prev.push(reflection + 1)
                const delay = `${idx * 0.25 + 0.25}s`;
                elem.style.animationDelay = delay;
                images[reflection + 1].style.animationDelay = delay;
                observer.observe(elem);
                observer.observe(images[reflection + 1]);
            } else if (prev.includes(idx) === false) {
                prev.push(idx)
                elem.style.animationDelay = `${idx * 0.25 + 0.25}s`;
                observer.observe(elem);
            }
            return prev;
        }, [])
    })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqua-ox-filter-out"]) return;
  try {
    
    const contaminants = document.querySelector('.contaminants');
    const maxHeight = contaminants.getBoundingClientRect().height;
    const button = contaminants.querySelector('button');
    const closedHeight = button.getBoundingClientRect().height;
    const content = contaminants.querySelector(`#contaminants`);
    contaminants.style.maxHeight = `${closedHeight}px`;
    content.setAttribute("aria-expanded", false);
    
    button.addEventListener("click", () => {
        const expand = content.getAttribute("aria-expanded") === 'false' ? true : false;
        content.setAttribute("aria-expanded", expand);
        button.classList.toggle("opened");
        
        if (expand) {
            contaminants.style.maxHeight = `${maxHeight}px`;
        } else {
            contaminants.style.maxHeight = `${closedHeight}px`;
        }
        
    })


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqua-ox-header"]) return;
  try {
    
const header = document.getElementById("aqua-ox-header");
const toggle = document.getElementById("toggle-menu");
const nav = document.getElementById("aqua-ox-nav");

toggle.addEventListener("click", () => {
    toggle.classList.toggle("open");
    nav.classList.toggle("open");

    nav.classList.contains("open") 
        ? nav.style.maxHeight = `${window.innerHeight - header.getClientRects()[0].top - header.getClientRects()[0].height}px`
        : nav.style.maxHeight = "0px"
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqua-ox-hero"] && !Shopify.designMode) return;
  try {
    
    const video = document.querySelector('video');
    const play = document.querySelector('.play');
    const pause = document.querySelector('.pause');
    video.addEventListener("ended", () => {
        video.play()
    });

    play.addEventListener("click", () => {
        video.play();
        video.classList.toggle("paused");
    })

    pause.addEventListener("click", () => {
        video.pause();
        video.classList.toggle("paused");
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqua-ox-icon-bar"] && !Shopify.designMode) return;
  try {
    
    (() => {
        if (window?.AquaOx?.animationController === undefined) {
            return console.warn("AquaOx Animations Disabled: Aqua Ox Animation Controller not present")
        }

        const observer = window.AquaOx.animationController.observer;

        // create the animation
        window.AquaOx.animationController.animations.push((entries) => {
            entries.forEach((entry) => {
                if (entry.target.classList.contains("aqua-ox-icon-img") === false) {
                    return;
                }
                if (entry.isIntersecting) {
                    entry.target.classList.add("animate");
                }
            })
        })

        // observe elem to play animation
        document.querySelectorAll(".aqua-ox-icon-bar .aqua-ox-icon-img").forEach((elem, idx) => {
            elem.style.animationDelay = `${idx * 0.5 + 0.5}s`
            observer.observe(elem)
        })
    })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aqua-ox-video"] && !Shopify.designMode) return;
  try {
    
    const modal = document.querySelector('#aqua-ox-video');
    const video = modal.querySelector('iframe');
    video.dataset.src = video.src;
    const btns = document.querySelectorAll('[aria-controls="aqua-ox-video"]');
    btns.forEach((btn) => {
        btn.addEventListener('click', () => {
            const expand = modal.getAttribute("aria-expanded") === "false" ? true : false;
            modal.setAttribute("aria-expanded", expand)
            modal.classList.toggle("open");
            expand 
                ? video.src = video.dataset.src 
                : video.src = ''
        })
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
